import { Alert, CollapseProps, Typography } from 'antd'

const { Title, Text } = Typography

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела</b>,
        children: (
            <>
                <p>
                    Раздел «Задачи дизайнера» показывает задачи подготовки, сгруппированные по
                    отгрузкам.
                </p>
                <ul>
                    <li>
                        В строке отгрузки отображаются клиент, номер заказа, менеджер, станки,
                        дополнительные работы и комментарии.
                    </li>
                    <li>
                        Ниже идут задачи этой отгрузки: номер, тип, детали, статус, дата создания,
                        исходники, бланки и действие «Завершить».
                    </li>
                    <li>
                        Кнопка <Text strong>«Обновить»</Text> перезагружает список.
                    </li>
                    <li>
                        В шапке можно отфильтровать задачи по статусу, номеру отгрузки и менеджеру.
                        Кнопка «Сброс» очищает фильтры.
                    </li>
                    <li>
                        Badge рядом с кнопкой показывает количество новых задач с момента открытия
                        страницы. Счетчик обновляется автоматически примерно раз в 3 минуты.
                    </li>
                    <li>
                        Завершение задач дизайнера, кроме «Отрисовка бланка», доступно только
                        после согласования задания куратором (статус отгрузки «Согласован»). Пока
                        согласование не получено, кнопка «Завершить» у этих задач заблокирована.
                        Задачу «Отрисовка бланка» можно завершить до согласования.
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '2',
        label: <b>Откуда берутся задачи и когда появляются</b>,
        children: (
            <>
                <p>Задачи появляются в двух основных точках процесса:</p>
                <Title level={3}>1) Перенос расчета в отгрузки</Title>
                <p>
                    При создании отгрузки из расчета обычно создается задача{' '}
                    <Text strong>«Отрисовка бланка»</Text>.
                </p>
                <Title level={3}>2) Запуск отгрузки</Title>
                <p>
                    После запуска отгрузки (Play в разделе «Отгрузки») система создает остальные
                    задачи в зависимости от параметров заказа: <Text strong>«Заказ форм»</Text>,{' '}
                    <Text strong>«Отрисовка штампа»</Text>, <Text strong>«Цифровой спуск»</Text> и
                    другие.
                </p>
                <Alert
                    showIcon
                    type='info'
                    message='Если у штампа нет чертежа, задача «Заказ форм» ожидает завершения задачи «Отрисовка штампа».'
                />
            </>
        ),
    },
    {
        key: '3',
        label: <b>Статусы задач</b>,
        children: (
            <>
                <p>В задачах используются статусы: Новая, В работе, Завершена, Отменена.</p>
                <ul>
                    <li>
                        В заголовке колонки <Text strong>«Статус»</Text> Badge показывает количество
                        ваших задач в статусе <Text strong>«Новая»</Text>.
                    </li>
                    <li>
                        В интерфейсе дизайнера основной шаг — завершить задачу кнопкой{' '}
                        <Text strong>«Завершить»</Text>.
                    </li>
                    <li>
                        Статусы <Text strong>«В работе»</Text> и <Text strong>«Отменена»</Text>{' '}
                        приходят с сервера.
                    </li>
                    <li>
                        Для задачи <Text strong>«Цифровой спуск»</Text> при статусе «Отменена»
                        кнопка завершения не отображается.
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '4',
        label: <b>Задача «Отрисовка бланка»</b>,
        children: (
            <>
                <p>
                    Нажмите <Text strong>«Завершить»</Text>, заполните форму и подтвердите закрытие
                    задачи. Это можно сделать до согласования отгрузки куратором.
                </p>
                <ul>
                    <li>
                        Добавьте список цветов (до 12 позиций). Цвета будут использованы для
                        заполнения бланка клиента до тех пор, пока с отгрузкой не будет связан набор
                        форм.
                    </li>
                    <li>
                        Загрузите минимум один PDF-файл с превью этикетки для бланка (можно
                        несколько файлов), каждый должен быть на новой странице. Превью
                        масштабируется вписать в центральную область (только уменьшение, без
                        увеличения), центрируется по горизонтали, по вертикали прижимается к верхней
                        границе зоны.
                    </li>
                    <li>После завершения файлы бланка и цвета сохраняются в отгрузку.</li>
                </ul>
                <p>
                    В колонке <Text strong>«Бланки»</Text> — просмотр бланков и скачивание рабочего
                    файла кнопкой <Text strong>«Превью»</Text>.
                </p>
            </>
        ),
    },
    {
        key: '5',
        label: <b>Задача «Отрисовка штампа»</b>,
        children: (
            <>
                <p>
                    В текущем процессе задача закрывается после подтверждения в модалке «Задача
                    отрисовки штампа».
                </p>
                <ul>
                    <li>
                        В модалке есть напоминание: загрузите макет штампа на сервер (вне этой
                        формы).
                    </li>
                    <li>
                        При необходимости включите флаг <Text strong>«Срочный заказ»</Text>.
                    </li>
                    <li>Нажмите «Завершить задачу».</li>
                </ul>
                <Alert
                    showIcon
                    type='warning'
                    message='Загрузка файла штампа через форму в этом разделе сейчас не используется.'
                />
            </>
        ),
    },
    {
        key: '6',
        label: <b>Задача «Заказ форм»</b>,
        children: (
            <>
                <p>
                    Для этой задачи открывается редактор набора форм. Сценарий зависит от типа
                    заказа:
                </p>
                <ul>
                    <li>
                        <Text strong>Первый заказ:</Text> создается новый набор, формы добавляются
                        вручную.
                    </li>
                    <li>
                        <Text strong>Перезаказ:</Text> открывается существующий набор, его можно
                        дополнять и корректировать.
                    </li>
                </ul>
                <p>
                    Брак прихода форм создаёт отдельную задачу{' '}
                    <Text strong>«Перезаказ форм»</Text>. В черновике заказа уже нужные пластины.
                </p>

                <Title level={3}>Что заполнять</Title>
                <ul>
                    <li>Цвет формы (hex).</li>
                    <li>Название цвета.</li>
                    <li>Старый номер формы (oldNum).</li>
                    <li>Переключатель «Заказать/Перезаказать» для строк формы.</li>
                </ul>

                <Title level={3}>Порядок действий</Title>
                <ol>
                    <li>
                        Сначала нажмите <Text strong>«Сохранить»</Text> внутри редактора.
                    </li>
                    <li>
                        После сохранения станет доступна кнопка{' '}
                        <Text strong>«Завершить задачу»</Text> в модалке.
                    </li>
                    <li>Завершите задачу.</li>
                </ol>
                <Alert
                    showIcon
                    type='info'
                    message='При сохранении создаются/обновляются Form Set, формы и Form Order. Количество форм в наборе должно соответствовать количеству форм в отгрузке.'
                />
            </>
        ),
    },
    {
        key: '7',
        label: <b>Задача «Цифровой спуск»</b>,
        children: (
            <>
                <p>Это самая короткая задача по шагам:</p>
                <ol>
                    <li>Нажмите «Завершить» в строке задачи.</li>
                    <li>Подтвердите действие в окне подтверждения.</li>
                </ol>
                <p>Дополнительной формы заполнения для этого типа задачи нет.</p>
            </>
        ),
    },
    {
        key: '8',
        label: <b>Частые вопросы</b>,
        children: (
            <>
                <Title level={3}>Не вижу кнопку «Завершить» у цифрового спуска</Title>
                <p>Для задачи «Цифровой спуск» кнопка скрывается, если задача уже отменена.</p>

                <Title level={3}>Почему «Завершить задачу» по формам неактивна</Title>
                <p>
                    Сначала нужно сохранить набор форм кнопкой «Сохранить» в редакторе набора форм.
                </p>

                <Title level={3}>Где взять исходники</Title>
                <p>
                    В колонке <Text strong>«Исходники»</Text> доступна ссылка на файлы, привязанные
                    к отгрузке.
                </p>

                <Title level={3}>Когда появляются бланки</Title>
                <p>
                    После загрузки PDF в задаче «Отрисовка бланка» в окне доступны
                    клиентский и производственный бланки — задачу можно закрыть позже, после
                    проверки.
                </p>

                <Title level={3}>
                    Почему задача форм не закрывается сразу после запуска отгрузки
                </Title>
                <p>
                    Если для этой отгрузки требуется отрисовка штампа без чертежа, сначала нужно
                    завершить задачу «Отрисовка штампа».
                </p>
            </>
        ),
    },
]
